var _rect, _path, _path2, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _ellipse, _rect1, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPassportFront(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 231,
    height: 157,
    viewBox: "0 0 231 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.06519,
    y: 1.28785,
    width: 228.454,
    height: 155.058,
    rx: 3.27273,
    fill: "#E8DCDE",
    stroke: "#C9C5C6",
    strokeWidth: 1.30909
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M205.109 4.74854H223.379C224.825 4.74854 225.997 5.92074 225.997 7.36672V150.267C225.997 151.713 224.825 152.885 223.379 152.885H205.109V4.74854Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M115.292 2.69006V154.942",
    stroke: "#C9C5C6",
    strokeWidth: 1.30909
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17.1206,
    y: 33.5511,
    width: 6.26627,
    height: 88.4706,
    rx: 3.13314,
    fill: "#A7989B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 81.8716,
    y: 31.4962,
    width: 6.26627,
    height: 41.1491,
    rx: 3.13314,
    fill: "#A7989B"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 132.002,
    y: 43.8384,
    width: 6.26627,
    height: 34.9768,
    rx: 3.13314,
    fill: "#A7989B"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 182.132,
    y: 43.8384,
    width: 6.26627,
    height: 34.9768,
    rx: 3.13314,
    fill: "#A7989B"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 157.067,
    y: 56.1841,
    width: 6.26627,
    height: 22.632,
    rx: 3.13314,
    fill: "#A7989B"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 81.8716,
    y: 84.9888,
    width: 6.26627,
    height: 45.264,
    rx: 3.13314,
    fill: "#A7989B"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 40.0974,
    y: 52.0686,
    width: 6.26627,
    height: 51.4364,
    rx: 3.13314,
    fill: "#A7989B"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 83.9619,
    y: 10.9207,
    width: 4.11491,
    height: 52.2189,
    rx: 2.05746,
    transform: "rotate(90 83.9619 10.9207)",
    fill: "#A7989B"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 186.31,
    y: 10.9207,
    width: 4.11491,
    height: 52.2189,
    rx: 2.05746,
    transform: "rotate(90 186.31 10.9207)",
    fill: "#A7989B"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.0048,
    cy: 90.1323,
    rx: 15.6657,
    ry: 15.4309,
    fill: "#BA1414",
    fillOpacity: 0.55
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 132.002,
    y: 91.1604,
    width: 60.574,
    height: 45.264,
    rx: 1.96364,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M162.831 114.545C162.831 109.512 157.8 105.432 151.594 105.432C145.388 105.432 140.357 106.772 140.357 114.545C140.357 122.318 145.388 123.658 151.594 123.658C157.8 123.658 162.831 119.578 162.831 114.545Z",
    fill: "#C6B6B9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M179.991 131.759C179.883 131.762 179.608 131.76 179.991 131.759V131.759Z",
    fill: "#C6B6B9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M180.285 97.3374C179.566 97.3357 180.181 97.3324 180.285 97.3374V97.3374Z",
    fill: "#C6B6B9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M179.535 97.3546C168.724 97.5234 165.643 98.9142 163.693 109.557C163.693 109.557 165.631 111.055 165.631 114.547C165.631 118.038 163.693 119.537 163.693 119.537C165.622 130.063 168.657 131.539 179.184 131.733C180.043 131.749 180.088 131.756 179.989 131.759C180.176 131.758 180.521 131.757 181.124 131.757C181.124 131.757 186.31 129.224 186.31 114.547C186.31 99.87 181.124 97.336 181.124 97.336C180.737 97.336 180.468 97.3358 180.284 97.3354C180.346 97.3382 180.226 97.3439 179.535 97.3546Z",
    fill: "#C6B6B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassportFront);
export default __webpack_public_path__ + "static/media/passport_front.cfec19701215332ff48ae73e444602b6.svg";
export { ForwardRef as ReactComponent };